import styled from 'styled-components';
import React from 'react';
import {
  ArrowDownRightIcon,
  ArrowUpRightIcon,
  Box,
  getOpenNetworkTheme,
  IconSize,
  OSmallParagraph,
} from '@lifechurch/react-ion';

interface Props {
  value: number;
}

interface StyledTrendTextProps {
  trend?: string;
}

const StyledTrendText = styled(OSmallParagraph)<StyledTrendTextProps>`
  color: ${props => {
    if (props.trend === 'positive') {
      return props.theme.colors.success.default;
    } else {
      return props.theme.colors.error.default;
    }
  }};
`;

const StyledTrendContainer = styled(Box)<StyledTrendTextProps>`
  flex-direction: row;
  display: flex;
  align-self: center;
  margin-inline-end: 5px;
`;

const AnalyticsOverviewTrend: React.FC<Props> = ({ value }) => {
  return (
    <>
      {value > 0 && (
        <StyledTrendContainer>
          <ArrowUpRightIcon
            color={getOpenNetworkTheme().colors.success.default}
            size={IconSize.SM}
          />
          <StyledTrendText trend='positive'>{value}%</StyledTrendText>
        </StyledTrendContainer>
      )}
      {value < 0 && (
        <StyledTrendContainer>
          <ArrowDownRightIcon
            color={getOpenNetworkTheme().colors.error.default}
            size={IconSize.SM}
          />
          <StyledTrendText trend='negative'>{Math.abs(value)}%</StyledTrendText>
        </StyledTrendContainer>
      )}
    </>
  );
};

export default AnalyticsOverviewTrend;
